import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { nouvelleVersionEnLigne } from '@/lib/versionEnLigne';

const INTERVALLE_MS = 5 * 60 * 1000;

/**
 * D-MAJ-RECHARGEMENT : une nouvelle version en ligne recharge l'app au prochain changement d'ecran, jamais
 * pendant une saisie (la garde de sortie, useGardeSortie, a deja laisse passer la navigation).
 * Verification toutes les 5 minutes et au retour sur l'onglet ; production seulement.
 */
export function useRechargementNouvelleVersion() {
  const { pathname } = useLocation();
  const nouvelleVersion = useRef(false);
  const cheminPrecedent = useRef(pathname);

  useEffect(() => {
    if (!import.meta.env.PROD) return;
    const verifier = async () => {
      if (await nouvelleVersionEnLigne()) nouvelleVersion.current = true;
    };
    const surRetour = () => {
      if (document.visibilityState === 'visible') void verifier();
    };
    const intervalle = window.setInterval(verifier, INTERVALLE_MS);
    document.addEventListener('visibilitychange', surRetour);
    return () => {
      window.clearInterval(intervalle);
      document.removeEventListener('visibilitychange', surRetour);
    };
  }, []);

  useEffect(() => {
    if (pathname === cheminPrecedent.current) return;
    cheminPrecedent.current = pathname;
    if (nouvelleVersion.current) window.location.reload();
  }, [pathname]);
}
